import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { breakpointBetween, breakpointDown, breakpointOnly, breakpointUp } from '../../system/mixins';
import { breakpointUnit, breakpointValues, forwardBreakpoints, forwardBreakpointsTwoArgs, mapBreakpointCodeToValue, mapBreakpointWidthToCode } from '../../system/mixins/breakpoints';
export var makeBreakpoints = function makeBreakpoints(breakpoints) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpointUnit;

  var _ref = breakpoints || {},
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? breakpointValues : _ref$values;

  var base = {
    values: values,
    keys: Object.keys(values),
    unit: unit
  };
  return _objectSpread(_objectSpread(_objectSpread({}, breakpoints), base), {}, {
    unit: unit,
    mapCodeToValue: function mapCodeToValue(value, spacing) {
      return mapBreakpointCodeToValue(base, value, spacing);
    },
    mapWidthToCode: function mapWidthToCode(value) {
      return mapBreakpointWidthToCode(base, value);
    },
    up: forwardBreakpoints(base, breakpointUp),
    down: forwardBreakpoints(base, breakpointDown),
    only: forwardBreakpoints(base, breakpointOnly),
    between: forwardBreakpointsTwoArgs(base, breakpointBetween)
  });
};